import { ExpandableList } from "react-migration/components/ExpandableList";
import { RecordType } from "react-migration/domains/comparables/typings/Record";
import { FC } from "react";
import { CompsListing } from "react-migration/domains/comparables/components/Results/CompsListing";
import { useComparablePrices } from "react-migration/domains/comparables/hooks/useComparablePrices";
import { userStore } from "src/js/stores/user/store";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Icon } from "react-migration/components/Icon";
import { getCurrencyFromLicense } from "react-migration/lib/util/numberFormat";

export interface ComparablesListProps {
  setSelectedRecord: (transaction: RecordType) => void;
  includedResults: RecordType[];
}

export const ComparablesList: FC<ComparablesListProps> = ({ includedResults, setSelectedRecord }) => {
  const locale = userStore.locale;
  const enhancedTransactions = useComparablePrices(
    includedResults,
    locale,
    getCurrencyFromLicense(),
    true // Filter out N/A prices
  );

  return (
    <ExpandableList limit={4} itemsName="comparables">
      {enhancedTransactions.length > 0 ? (
        enhancedTransactions.map((transaction, index) => {
          return (
            <CompsListing
              transaction={transaction}
              onSelected={() => setSelectedRecord(transaction)}
              key={`${transaction.transaction_id}-comparable-item-${index}`}
            />
          );
        })
      ) : (
        <NoComparables />
      )}
    </ExpandableList>
  );
};

const NoComparables = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-2 p-10 text-center bg-background-secondary">
      <div className="p-2.5 mb-6 bg-blue-grey-100 rounded-full">
        <Icon icon="icon-lt-seo-line" size="lg" />
      </div>
      <h5 className="text-lg text-blue-grey-950">{t("workbench.contextual_tab.nearby.no_comparables.title")}</h5>
      <p className="m-0 text-sm text-blue-grey-950">
        {t("workbench.contextual_tab.nearby.no_comparables.description")}
      </p>
    </div>
  );
};
